module.exports = require("inspector");